/**
 * A one-shot hand-off from the Results tab to the Game tab: "show this
 * square". The pool route's search params belong to the pool screen, so the
 * request rides here instead and the Game tab takes it once when it mounts.
 */
export type typeSquaresFocusRequest = {
  poolId: string;
  gridId: string;
  eventId: string | null;
  squareKey: string | null;
};

let pending: typeSquaresFocusRequest | null = null;

export function requestSquaresFocus(request: typeSquaresFocusRequest): void {
  pending = request;
}

/** Hands the request over once, and only to the pool it was made for. */
export function takeSquaresFocus(
  poolId: string,
): typeSquaresFocusRequest | null {
  if (pending === null || pending.poolId !== poolId) return null;
  const request = pending;
  pending = null;
  return request;
}
